import { render, staticRenderFns } from "./PwdReset.vue?vue&type=template&id=777f6ed9&scoped=true&"
import script from "./PwdReset.vue?vue&type=script&lang=js&"
export * from "./PwdReset.vue?vue&type=script&lang=js&"
import style0 from "./PwdReset.vue?vue&type=style&index=0&id=777f6ed9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f6ed9",
  null
  
)

export default component.exports